import type { ReactNode } from "react";

export interface DefinitionEntry {
  term: ReactNode;
  /** 传入数组时逐行渲染（原型用 `<br>` 分隔，此处等价）。 */
  value: ReactNode | ReactNode[];
}

export interface DefinitionListProps {
  entries: DefinitionEntry[];
}

/** 原型基元：`.definition-list`（故事结构检视面板的“进入与退出”）。 */
export function DefinitionList({ entries }: DefinitionListProps) {
  return (
    <dl className="definition-list">
      {entries.map((entry, index) => (
        <div key={index} style={{ display: "contents" }}>
          <dt>{entry.term}</dt>
          <dd>
            {Array.isArray(entry.value)
              ? entry.value.map((line, lineIndex) => (
                  <span key={lineIndex} style={{ display: "block" }}>
                    {line}
                  </span>
                ))
              : entry.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
